import { ModuleWithProviders, NgModule } from '@angular/core';

import { IntrojsDirective } from './introjs.directive';
import { IntrojsService } from './introjs.service';
import { WindowRef } from 'app/shared/services/window-ref';
import { TranslateModule } from '../i18n/translate.module';

@NgModule({
	declarations: [ IntrojsDirective ],
	exports: [ IntrojsDirective ],
	imports: [ TranslateModule ]
})
export class IntrojsModule {
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: IntrojsModule,
			providers: [IntrojsService, WindowRef],
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/introjs/introjs.module.ts